"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.equalsEnum = void 0;
// Check if a string equals one of the values in a given enum.
var equalsEnum = function (enumValues, valueToCheck) {
    return Object.values(enumValues).includes(valueToCheck);
};
exports.equalsEnum = equalsEnum;
